// Functions
/*!
 * Basic functions
 */

//
//
//

// --------------------------------------------------------------------------------
// Function: Enable/disable buttons inside .modal while ongoing ajax requests
//

window.disableModalButtons = function ($modal, $triggerButton, loadingText) {
  // Select all <button> elements and elements with .btn class inside the modal
  var allElems = $modal.find("button, .btn").get();
  var uniqueElems = $.uniqueSort(allElems);
  var $allInteractive = $(uniqueElems);

  // Store original disabled state and disable elements
  $allInteractive.each(function () {
    var $el = $(this);
    var wasDisabled = $el.is("button") ? $el.prop("disabled") : $el.hasClass("disabled");
    $el.data("wasDisabled", wasDisabled);
    if ($el.is("button")) {
      $el.prop("disabled", true);
    } else {
      $el.addClass("disabled");
    }
  });

  // Modify the trigger button
  if ($triggerButton.length) {
    $triggerButton.data("original-text", $triggerButton.html()); // Store original text
    $triggerButton.html('<span class="spinner-border spinner-border-sm"></span> ' + loadingText); // Change to loading state
  }

  return { $allInteractive, $triggerButton };
};

window.enableModalButtons = function ($allInteractive, $triggerButton) {
  // Re-enable only elements that were not originally disabled
  $allInteractive.each(function () {
    var $el = $(this);
    var wasDisabled = $el.data("wasDisabled");
    if (!wasDisabled) {
      if ($el.is("button")) {
        $el.prop("disabled", false);
      } else {
        $el.removeClass("disabled");
      }
    }
    $el.removeData("wasDisabled");
  });

  // Restore trigger button text
  if ($triggerButton.length) {
    var originalText = $triggerButton.data("original-text");
    if (originalText) {
      $triggerButton.html(originalText);
    }
  }
};

/* Orders count badge updater (.badge-orders-count) */
window.mealOrdersTotal = (function () {
  var selector = ".badge-orders-count";
  var currentCount = null;

  function toSafeCount(value) {
    var n = parseInt(value, 10);
    if (isNaN(n) || n < 0) n = 0;
    return n;
  }

  function render(count) {
    var $badges = $(selector);
    if (!$badges.length) return count;

    if (currentCount === count) return count; // no unnecessary repaint
    currentCount = count;

    $badges.text(count);
    $badges.toggleClass("d-none", count === 0);
    $badges.attr("aria-hidden", count === 0 ? "true" : "false");
    return count;
  }

  function set(count) {
    return render(toSafeCount(count));
  }

  // Optional fallback when DB count isn't available
  function add(delta) {
    var d = parseInt(delta, 10);
    if (isNaN(d)) d = 0;

    var base = currentCount;
    if (base === null) {
      base = toSafeCount($(selector).first().text());
    }

    return render(toSafeCount(base + d));
  }

  function initFromDom() {
    return set($(selector).first().text());
  }

  return {
    set: set, // preferred
    add: add, // fallback only
    initFromDom: initFromDom,
  };
})();

$(function () {
  window.mealOrdersTotal.initFromDom();
});

// Global rules (single source of truth)
window.foodMenuRules = window.foodMenuRules || {};
if (typeof window.foodMenuRules.mealTypeLimit === "undefined") {
  window.foodMenuRules.mealTypeLimit = 6; // debug override (default 6)
}
if (typeof window.foodMenuRules.forceShowMealTypeFilter === "undefined") {
  window.foodMenuRules.forceShowMealTypeFilter = false; // debug override (default false)
}

// Show/hide meal-type filter based on loaded count + available meal types
window.configureMealTypeFilter = function (ordersLoaded) {
  var limit = parseInt(window.foodMenuRules.mealTypeLimit, 10);
  if (isNaN(limit)) limit = 6;

  var $filterWrap = $("#select-meal-type");
  var $meals = $("#meals .meal");

  var totalCount = parseInt(ordersLoaded, 10);
  if (isNaN(totalCount)) {
    totalCount = $meals.length; // fallback if backend value missing
  }

  var hotCount = $meals.filter(function () {
    return $(this).data("meal-type") === "hot-meal";
  }).length;

  var coldCount = $meals.filter(function () {
    return $(this).data("meal-type") === "cold-meal";
  }).length;

  var $hotInput = $("#tople-malice");
  var $coldInput = $("#hladne-malice");
  var $hotLabel = $hotInput.closest("label");
  var $coldLabel = $coldInput.closest("label");

  function setHotDefault() {
    $hotInput.prop("checked", true);
    $coldInput.prop("checked", false);
    $hotLabel.addClass("active");
    $coldLabel.removeClass("active");
  }

  function showAllMeals() {
    $meals.removeClass("d-none");
  }

  function hideFilter(reason) {
    $filterWrap.addClass("d-none");
    showAllMeals();
    setHotDefault(); // reset state for next load
    console.log("[meal-filter] hidden:", reason);
  }

  function showFilter(reason) {
    $filterWrap.removeClass("d-none");
    setHotDefault(); // hot default
    if (typeof window.applyMealFilter === "function") {
      window.applyMealFilter();
    }
    console.log("[meal-filter] shown:", reason);
  }

  if (window.foodMenuRules.forceShowMealTypeFilter === true) {
    showFilter(
      "Forced by debug flag. " + "Count " + totalCount + " > " + limit + ", hot=" + hotCount + ", cold=" + coldCount,
    );
    return;
  }

  var hasHot = hotCount > 0;
  var hasCold = coldCount > 0;
  var isMixed = hasHot && hasCold;
  var shouldShow = totalCount > limit && isMixed;

  if (shouldShow) {
    showFilter("count " + totalCount + " > " + limit + ", hot=" + hotCount + ", cold=" + coldCount);
    return;
  }

  coldCount >= limit;

  if (totalCount <= limit) {
    hideFilter("count " + totalCount + " <= threshold " + limit);
    return;
  }

  hideFilter("single type only (hot=" + hotCount + ", cold=" + coldCount + ")");
};

window.resetFoodMenuModalsHost = function () {
  $("#foodMenuModalsHost .modal.show").modal("hide");
  $("#foodMenuModalsHost").empty();
  $(".modal-backdrop").remove();
  $("body").removeClass("modal-open").css("padding-right", "");
};

window.syncFoodMenuOrderAlreadyPlacedWarnings = function () {
  var $modals = $("#foodMenuModalsHost .modal");
  if (!$modals.length) {
    return;
  }

  var warningSelector = ".warning-order-already-placed";
  $modals.find(warningSelector).addClass("d-none");

  var $meals = $("#meals");
  if (!$meals.length || $meals.hasClass("multiorderTag")) {
    return;
  }

  var selectedModalSelectors = [];
  $meals.find(".meal.selected").each(function () {
    var targetSelector = $(this).data("target");
    if (typeof targetSelector === "string" && targetSelector.trim()) {
      selectedModalSelectors.push(targetSelector.trim());
    }
  });

  if (!selectedModalSelectors.length) {
    return;
  }

  $modals.find(warningSelector).removeClass("d-none");

  selectedModalSelectors.forEach(function (targetSelector) {
    if (targetSelector.charAt(0) === "#") {
      var modalId = targetSelector.slice(1);
      if (modalId) {
        var modalElement = document.getElementById(modalId);
        if (modalElement) {
          $(modalElement).find(warningSelector).addClass("d-none");
        }
      }
      return;
    }

    try {
      $(targetSelector).find(warningSelector).addClass("d-none");
    } catch (e) {
      // Ignore invalid selectors from malformed data-target values.
    }
  });
};

window.isFoodMenuStockCheckEnabled = function () {
  return !$("#meals").hasClass("noStockCheck");
};

window.normalizeFoodMenuStockToken = function (value) {
  if (typeof value !== "string") {
    return null;
  }

  var normalized = $.trim(value)
    .replace(/^gotrid_/i, "")
    .toUpperCase();
  if (normalized === "NO_ACCESSORIES") {
    return "NO_EXTRA";
  }
  if (normalized === "NO_MAINDISH" || normalized === "NO_SIDEDISH" || normalized === "NO_EXTRA") {
    return normalized;
  }

  return null;
};

window.normalizeFoodMenuStockResponse = function (response) {
  if (!response || typeof response !== "object" || Array.isArray(response)) {
    return response;
  }

  var normalizedResponse = $.extend({}, response);

  ["result", "resultAccessories", "resultSidedish", "gotrId"].forEach(function (fieldName) {
    var fieldValue = normalizedResponse[fieldName];
    var normalizedToken = window.normalizeFoodMenuStockToken(fieldValue);

    if (normalizedToken) {
      normalizedResponse[fieldName] = normalizedToken;
      return;
    }

    if (typeof fieldValue === "string") {
      normalizedResponse[fieldName] = fieldValue.replace(/NO_ACCESSORIES/gi, "NO_EXTRA");
    }
  });

  return normalizedResponse;
};

window.getFoodMenuStockCodeFromResponse = function (response) {
  if (!response || typeof response !== "object") {
    return null;
  }

  var resolvedCode =
    window.normalizeFoodMenuStockToken(response.resultSidedish) ||
    window.normalizeFoodMenuStockToken(response.resultAccessories) ||
    window.normalizeFoodMenuStockToken(response.gotrId) ||
    window.normalizeFoodMenuStockToken(response.result);

  if (resolvedCode) {
    return resolvedCode;
  }

  var resultText = String(response.result || "").toUpperCase();
  if (resultText.indexOf("NO_MAINDISH") !== -1) {
    return "NO_MAINDISH";
  }
  if (resultText.indexOf("NO_SIDEDISH") !== -1) {
    return "NO_SIDEDISH";
  }
  if (resultText.indexOf("NO_EXTRA") !== -1) {
    return "NO_EXTRA";
  }
  if (resultText.indexOf("NO_ACCESSORIES") !== -1) {
    return "NO_EXTRA";
  }

  return null;
};

window.setFoodMenuStockDishIndicator = function ($modal, indicatorState) {
  if (!$modal || !$modal.length) return;

  var $indicator = $modal.find(".stock-dish-indicator");
  if (!$indicator.length) {
    return;
  }

  var indicatorSelectorByState = {
    UNLIMITED: ".stock-dish-unlimited",
    LIMITED: ".stock-dish-limited",
    NONE: ".stock-dish-none-group",
  };

  var targetSelector = indicatorSelectorByState[indicatorState];
  if (!targetSelector) {
    return;
  }

  $indicator.find(".stock-dish-unlimited, .stock-dish-limited, .stock-dish-none-group").addClass("d-none");
  $indicator.find(targetSelector).removeClass("d-none");
};

window.resetFoodMenuStockWarnings = function ($scope) {
  var $targetScope = $scope && $scope.length ? $scope : $(document);
  $targetScope.find(".stock-no-dish, .stock-no-side-dish, .stock-no-extra").addClass("d-none");

  // also clear NO_MAINDISH UI lock inside scope
  if ($targetScope.hasClass("modal")) {
    window.toggleFoodMenuNoMainDishUi($targetScope, false);
  }
  $targetScope.find(".modal").each(function () {
    window.toggleFoodMenuNoMainDishUi($(this), false);
  });
};

window.showFoodMenuStockWarning = function ($modal, stockCode) {
  if (!$modal || !$modal.length) return;

  window.resetFoodMenuStockWarnings($modal); // clears warnings + restores UI lock first

  var warningSelectorByCode = {
    NO_MAINDISH: ".stock-no-dish",
    NO_SIDEDISH: ".stock-no-side-dish",
    NO_EXTRA: ".stock-no-extra",
  };

  var warningSelector = warningSelectorByCode[stockCode];
  if (warningSelector) {
    $modal.find(warningSelector).removeClass("d-none");
  }

  if (stockCode === "NO_MAINDISH") {
    window.setFoodMenuStockDishIndicator($modal, "NONE");
    window.toggleFoodMenuNoMainDishUi($modal, true); // hide .btn-save-close + .tab-btns
  }
};

window.handleFoodMenuStockResponse = function ($modal, response) {
  if (!window.isFoodMenuStockCheckEnabled()) {
    return false;
  }

  var stockCode = window.getFoodMenuStockCodeFromResponse(response);
  if (!stockCode) {
    return false;
  }

  window.showFoodMenuStockWarning($modal, stockCode);
  return true;
};

window.toggleFoodMenuNoMainDishUi = function ($modal, shouldHide) {
  if (!$modal || !$modal.length) return;

  $modal.find(".btn-save-close, .tab-btns").each(function () {
    var $el = $(this);
    var key = "stockNoMainDishPrevHidden";

    if (shouldHide) {
      if (typeof $el.data(key) === "undefined") {
        $el.data(key, $el.hasClass("d-none")); // remember prior state
      }
      $el.addClass("d-none");
      return;
    }

    var wasHidden = $el.data(key);
    if (typeof wasHidden !== "undefined") {
      $el.toggleClass("d-none", !!wasHidden); // restore prior state
      $el.removeData(key);
    }
  });
};

window.parseBooleanDataAttribute = function (value) {
  if (typeof value === "boolean") {
    return value;
  }

  if (typeof value === "number") {
    return value === 1;
  }

  if (typeof value === "string") {
    var normalized = value.trim().toLowerCase();
    if (normalized === "true" || normalized === "1" || normalized === "yes") {
      return true;
    }
    if (normalized === "false" || normalized === "0" || normalized === "no") {
      return false;
    }
  }

  return false;
};

window.normalizeDishExtraText = function (value) {
  if (value === null || typeof value === "undefined") {
    return "";
  }

  return String(value)
    .replace(/\u00A0/g, " ")
    .trim();
};

window.normalizeDishExtraForDisplay = function (value, fallbackText) {
  var normalized = window.normalizeDishExtraText(value);
  var fallback = typeof fallbackText === "undefined" ? "/" : String(fallbackText);

  if (!normalized) {
    return fallback;
  }

  return normalized;
};

window.getSelectedDishAdditionIds = function ($scope) {
  var $targetScope = $scope && $scope.length ? $scope : $(document);
  var ids = [];

  $targetScope.find(".obrok-dodatki .selected").each(function () {
    ids.push($(this).data("dish-addition"));
  });

  return ids;
};

window.getSelectedDishAdditionText = function ($scope, fallbackText) {
  var $targetScope = $scope && $scope.length ? $scope : $(document);
  var selectedText = $targetScope
    .find(".obrok-dodatki .selected")
    .map(function () {
      return $(this).text().trim();
    })
    .get()
    .join(", ");

  return window.normalizeDishExtraForDisplay(selectedText, fallbackText);
};

window.resetFoodMenuDishAdditionsAfterCancel = function ($modal, $openerDiv, fallbackText) {
  if (!$modal || !$modal.length) {
    return window.normalizeDishExtraForDisplay("", fallbackText);
  }

  var fallback = window.normalizeDishExtraForDisplay("", fallbackText);
  var $resolvedOpener = $openerDiv && $openerDiv.length ? $openerDiv : $();
  var $targetScope = $resolvedOpener.length ? $resolvedOpener.add($modal) : $modal;

  $modal.find(".obrok-dodatki .selected").removeClass("selected");
  $targetScope.find(".dish-addition strong").text(fallback);

  if (typeof window.syncFoodMenuDishAdditionVisibility === "function") {
    window.syncFoodMenuDishAdditionVisibility($targetScope);
  }

  return fallback;
};

window.isDishExtraEmptyOrSlash = function (value) {
  var normalized = window.normalizeDishExtraText(value);
  return normalized === "" || normalized === "/";
};

window.updateDishExtraVisibility = function ($scope, options) {
  var opts = options && typeof options === "object" ? options : {};
  var selectors = Array.isArray(opts.selectors) && opts.selectors.length ? opts.selectors : [".dish-addition"];
  var forceVisible = !!opts.forceVisible;
  var $targetScope = $scope && $scope.length ? $scope : $(document);

  selectors.forEach(function (selector) {
    $targetScope.find(selector).each(function () {
      var $row = $(this);
      var rowText = $row.find("strong").first().text();
      var shouldHide = !forceVisible && window.isDishExtraEmptyOrSlash(rowText);
      $row.toggleClass("d-none", shouldHide);
    });
  });
};

window.isFoodMenuSelectedLocationAccessoriesEnabled = function () {
  var rawValue = $("#locations .btn.selected").first().attr("data-accessories");
  return window.parseBooleanDataAttribute(rawValue);
};

window.getMyTrayAccessoriesEnabled = function ($scope) {
  var $targetScope = $scope && $scope.length ? $scope : $(document);
  var $marker = $targetScope.filter(".order-location[data-accessories]").first();

  if (!$marker.length) {
    $marker = $targetScope.find(".order-location[data-accessories]").first();
  }

  var rawValue = $marker.attr("data-accessories");
  return window.parseBooleanDataAttribute(rawValue);
};

window.syncFoodMenuDishAdditionVisibility = function ($scope) {
  window.updateDishExtraVisibility($scope, {
    selectors: [".dish-addition"],
    forceVisible: window.isFoodMenuSelectedLocationAccessoriesEnabled(),
  });
};

window.syncMyTrayDishAdditionVisibility = function ($scope, forceVisible) {
  var resolvedForceVisible =
    typeof forceVisible === "undefined" ? window.getMyTrayAccessoriesEnabled($scope) : !!forceVisible;

  window.updateDishExtraVisibility($scope, {
    selectors: [".dish-addition"],
    forceVisible: resolvedForceVisible,
  });
};

window.normalizeFoodMenuNullLike = function (value) {
  if (value === null || typeof value === "undefined") {
    return null;
  }

  var rawString = String(value);
  var trimmedValue = rawString.trim();

  if (trimmedValue === "" || trimmedValue.toLowerCase() === "null") {
    return null;
  }

  return value;
};

window.escapeFoodMenuHtml = function (value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
};

window.foodMenuFallbackDisplay = function (value, fallbackText) {
  var normalized = window.normalizeFoodMenuNullLike(value);
  var fallback = typeof fallbackText === "undefined" ? "/" : String(fallbackText);
  if (normalized === null) {
    return fallback;
  }
  return String(value);
};

window.mapFoodMenuDetailsResponse = function (rawResponse) {
  var responseObject = rawResponse;
  if (!responseObject || typeof responseObject !== "object" || Array.isArray(responseObject)) {
    responseObject = {};
  }

  var mapped = {
    lhmAllergens: {},
    lhmEnergy: {},
  };

  if (
    responseObject.lhmAllergens &&
    typeof responseObject.lhmAllergens === "object" &&
    !Array.isArray(responseObject.lhmAllergens)
  ) {
    mapped.lhmAllergens = responseObject.lhmAllergens;
  }

  if (
    responseObject.lhmEnergy &&
    typeof responseObject.lhmEnergy === "object" &&
    !Array.isArray(responseObject.lhmEnergy)
  ) {
    mapped.lhmEnergy = responseObject.lhmEnergy;
  }

  return mapped;
};

window.renderFoodMenuAllergens = function ($modal, lhmAllergens, fallbackText) {
  var $allergensGroup = $modal.find(".allergensGroup");
  var allergensMap = lhmAllergens;
  if (!allergensMap || typeof allergensMap !== "object" || Array.isArray(allergensMap)) {
    allergensMap = {};
  }

  var fallback = typeof fallbackText === "undefined" ? "/" : String(fallbackText);
  var html = "";
  var groupNames = Object.keys(allergensMap);

  if (!groupNames.length) {
    html =
      '<div class="allergensItemGroup">' +
      '<span class="allergen-chip">' +
      window.escapeFoodMenuHtml(fallback) +
      "</span>" +
      '<div class="allergenItemGroup">' +
      '<div class="allergenItem">' +
      '<span class="allergenItemName" scope="row">' +
      window.escapeFoodMenuHtml(fallback) +
      "</span>" +
      '<p class="allergenItemValue">' +
      window.escapeFoodMenuHtml(fallback) +
      "</p>" +
      "</div>" +
      "</div>" +
      "</div>";
  } else {
    groupNames.forEach(function (groupName) {
      var items = allergensMap[groupName];
      if (!Array.isArray(items) || !items.length) {
        items = [{}];
      }

      var groupHtml =
        '<div class="allergensItemGroup">' +
        '<span class="allergen-chip">' +
        window.escapeFoodMenuHtml(window.foodMenuFallbackDisplay(groupName, fallback)) +
        "</span>" +
        '<div class="allergenItemGroup">';

      items.forEach(function (item) {
        var itemData = item && typeof item === "object" ? item : {};
        var itemName = window.foodMenuFallbackDisplay(itemData.itemName, fallback);
        var allergenValues = window.foodMenuFallbackDisplay(itemData.allergens, fallback);

        groupHtml +=
          '<div class="allergenItem">' +
          '<span class="allergenItemName" scope="row">' +
          window.escapeFoodMenuHtml(itemName) +
          ": " +
          "</span>" +
          '<p class="allergenItemValue">' +
          window.escapeFoodMenuHtml(allergenValues) +
          "</p>" +
          "</div>";
      });

      groupHtml += "</div></div>";
      html += groupHtml;
    });
  }

  $allergensGroup.empty().append(html).removeClass("d-none");
  $modal.find(".obrok-alergeni-tab #loadingSpinner").addClass("d-none");
};

window.renderFoodMenuNutrients = function ($modal, lhmEnergy, nutrientKeys, nutrientLabels, fallbackText) {
  var $table = $modal.find(".nutrientsTable");
  var $tbody = $table.find("tbody");
  var energyMap = lhmEnergy;
  if (!energyMap || typeof energyMap !== "object" || Array.isArray(energyMap)) {
    energyMap = {};
  }

  var keys = Array.isArray(nutrientKeys) ? nutrientKeys : [];
  var labels = nutrientLabels && typeof nutrientLabels === "object" ? nutrientLabels : {};
  var fallback = typeof fallbackText === "undefined" ? "/" : String(fallbackText);

  var rowsHtml = "";
  keys.forEach(function (key) {
    var label = labels[key] || key;
    var value = window.foodMenuFallbackDisplay(energyMap[key], fallback);
    rowsHtml +=
      '<tr class="nutrientItemGroup">' +
      '<th class="nutrientItemName" scope="row">' +
      window.escapeFoodMenuHtml(label) +
      "</th>" +
      '<td class="nutrientItemValue">' +
      window.escapeFoodMenuHtml(value) +
      "</td>" +
      "</tr>";
  });

  $tbody.empty().append(rowsHtml);
  $table.removeClass("d-none");
  $modal.find(".obrok-specifikacije-tab #loadingSpinner").addClass("d-none");
};
